import { Button, Heading, SvgX } from '@grubhubprod/gh-cookbook-react';
import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import React, { useEffect, useState } from 'react';
import { useAddNewPeopleCSVModalAnalytics } from 'src/components/AddNewPeopleCSVModal/AddNewPeopleCSVModalAnalytics';
import { CSVUploadTracking } from 'src/components/CSVUploadTracking/CSVUploadTracking';
import {
  defaultUploadStatus,
  UploadStatus,
} from 'src/components/CSVUploadTracking/CSVUploadTracking.utils';
import { Modal } from 'src/components/Modal/Modal';

interface IAddNewPeopleCSVModal {
  onSuccess: (employeeCount: number) => void;
  corpId: string;
  onClose: () => void;
}

export function AddNewPeopleCSVModal({
  corpId,
  onClose,
  onSuccess,
}: IAddNewPeopleCSVModal): JSX.Element {
  const [employeeCount, setEmployeeCount] = useState<number>(0);
  const [uploadStatus, setUploadStatus] =
    useState<UploadStatus>(defaultUploadStatus);
  const { sendAnalyticsByUploadStatus } = useAddNewPeopleCSVModalAnalytics();

  useEffect(() => {
    sendAnalyticsByUploadStatus(uploadStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadStatus.status]);

  function onModalSuccess() {
    onSuccess(employeeCount);
    onClose();
  }

  return (
    <Modal size="sm">
      <Square as="header" dimension="2" width="100%">
        <Button
          variant="tertiary"
          type="button"
          className="closeModalButton"
          onClick={onClose}
        >
          <SvgX aria-label="close" size="24px" />
        </Button>
        <Square inset="md">
          <Heading variant="h1">Import new people via CSV</Heading>
        </Square>
      </Square>
      <Square inset="md">
        <CSVUploadTracking
          corpId={corpId}
          uploadedRecordsTotalCb={(employeeCount) =>
            setEmployeeCount(employeeCount)
          }
          updateCurrentUploadStatusCb={setUploadStatus}
          showTryAgainBtn
        />
      </Square>
      <Square as="footer" dimension="2" inset="md">
        <Button
          block
          variant="primary"
          buttonSize="medium"
          disabled={!employeeCount}
          onClick={onModalSuccess}
        >
          Done
        </Button>
      </Square>
    </Modal>
  );
}
